<script>
    let eggzLeaderboardData;
    let lbOffset = 0;

    async function getApiEggzData() {
        let response = await fetch("https://api.eggz.chi.kn/stats/eggzdata");
        return await response.json()
    }

    const eggzPromise = getApiEggzData();
</script>

<section class="bg-header rounded-lg p-4">
    <div class="bg-background w-full rounded-lg p-4 text-center">
        <div class="text-3xl sm:text-5xl font-extrabold text-accent text-bold py-1 flex justify-center">
            <div>
                EGGZ LEADERBOARD
            </div>
        </div>
    </div>
    {#await eggzPromise}
        <p>Loading....</p>
    {:then eggz}
        <section class="lg:gap-6 gap-4 pt-4 text-center">
            <div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
                <button style="border: none" on:click={() => {
											lbOffset = 0
											}}>
                    &#60&#60;
                </button>
                &nbsp
                <button style="border: none" on:click={() => {
											if(lbOffset >= 10)
												lbOffset -= 10
											}}>
                    &#60;
                </button>
                &nbsp; &nbsp; Page {lbOffset/10 +1} &nbsp; &nbsp;
                <button style="border: none" on:click={() => {
											if(lbOffset <= 480)
												lbOffset += 10
										}}>
                    &#62;
                </button>
                &nbsp
                <button style="border: none" on:click={() => {
											lbOffset = 490
											}}>
                    &#62&#62;
                </button>
            </div>
        </section>
        <section class="flex lg:flex-row flex-col lg:gap-6 gap-4 pt-4">
            <div class="bg-background w-full rounded-lg p-4 text-center flex-container">
                <table>
                    <thead>
                        <tr>
                            <th></th>
                            <th><span class="text-accent">RANK</span></th>
                            <th><span class="text-accent">TOKEN ID</span></th>
                            <th><span class="text-accent">NAME</span></th>
                            <th><span class="text-accent">KG</span></th>
                            <th><span class="text-accent">EMITS</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each Array(10) as _, i}
                            <tr style="background-color: {i % 2 ? '#191a32' : '#2a2c54'}">
                                <td>
                                    <img src="{eggz[i + lbOffset].image}" class="egglbimage">
                                </td>
                                <td>
                                    <span class="text-secondary">{i + 1 + lbOffset}</span>
                                </td>
                                <td>
                                    <span class="text-secondary">{eggz[i + lbOffset].token_id}</span>
                                </td>
                                <td>
                                    <span class="text-secondary">{eggz[i + lbOffset].name}</span>
                                </td>
                                <td>
                                    <span class="text-secondary">{eggz[i + lbOffset].kg}</span>
                                </td>
                                <td>
                                    <span class="text-secondary">{eggz[i + lbOffset].emit}</span>
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        </section>
        <section class="lg:gap-6 gap-4 pt-4 text-center">
            <div class="sm:text-3xl font-extrabold text-accent gap-2 text-bold py-1">
                <button style="border: none" on:click={() => {
											lbOffset = 0
											}}>
                    &#60&#60;
                </button>
                &nbsp
                <button style="border: none" on:click={() => {
											if(lbOffset >= 10)
												lbOffset -= 10
											}}>
                    &#60;
                </button>
                &nbsp; &nbsp; Page {lbOffset/10 +1} &nbsp; &nbsp;
                <button style="border: none" on:click={() => {
											if(lbOffset <= 480)
												lbOffset += 10
										}}>
                    &#62;
                </button>
                &nbsp
                <button style="border: none" on:click={() => {lbOffset = 490
											}}>
                    &#62&#62;
                </button>
            </div>
        </section>
    {/await}
</section>